class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, null, this.dataset.variantid);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (!(event?.target?.id === "redemption-options" && event?.target?.classList?.contains("swell-rewards-points"))) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.variantid);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const sectionElement = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      if (parsedState.sections) {
        const htmlToPass = parsedState.sections[section.id] || parsedState.sections[section.section];
        sectionElement.innerHTML = this.getSectionInnerHTML(htmlToPass, section.selector);
      } else {
        window.location.pathname = "/cart";
      }
    }));
  }

  updateQuantity(line, quantity, name, variantID) {
    this.enableLoading(line);

    /* TODO : Go#120323b */
    const free_gift_variant_id = 44759620649137;
    if (quantity == 0 && variantID == free_gift_variant_id) {
      //document.cookie = `removed_free_gift=${free_gift_variant_id}; expires=${new Date(((new Date()) * 1) + (24 * 3600 * 1000))}; path=/`;
      //$(".free-gift-box .atc-btn").show();
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.renderContents(parsedState);

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        /* TODO : Go#120323c */
        const currDate = new Date() * 1;
        const startDate = new Date("Fri Oct 25 2024 00:00:00 GMT-0600 (Central Standard Time)") * 1;
        const endDate = currDate * 0;// new Date("Fri Nov 01 2024 23:59:00 GMT-0600 (Central Standard Time)") * 1;
        if (parsedState.item_count > 0 && currDate >= startDate && currDate <= endDate) {
          const free_gift_lines = parsedState.items.filter(line => line.variant_id == free_gift_variant_id && line.properties?.["_free_gift"] == "true")
          let free_gift_applied = !!free_gift_lines.length;

          const removeItem = itemToRemove => {
            const removeFormData = {
              id: itemToRemove.key,
              quantity: 0,
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname
            };

            fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(removeFormData)
            }).then((response) => {
              return response.text();
            }).then((innerState) => {
              const innerParsedState = JSON.parse(innerState);
              this.renderContents(innerParsedState);
            });
          };

          free_gift_lines.filter(line => line.final_price > 0).forEach(removeItem);

          if (parsedState.items_subtotal_price >= 4900) {
            const removedCookie = document.cookie.match(/removed_free_gift=(\d+)/)?.[1] ?? "";
            if (removedCookie == free_gift_variant_id) {
              $(".free-gift-box .atc-btn").show();
            } else if (!free_gift_applied) {
              const addFormData = {
                items: [{
                  id: free_gift_variant_id,
                  properties: { '_free_gift': 'true' },
                  quantity: 1
                }],
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              };
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(addFormData)
              }).then(response => response.text()).then(innerState => {
                const innerParsedState = JSON.parse(innerState);
                const undiscounted = innerParsedState.items.filter(item => item.final_price > 1);
                if (undiscounted.length) {
                  undiscounted.forEach(removeItem);
                }
                this.renderContents(innerParsedState);
              });
            }
          } else {
            if (free_gift_lines.length) {
              free_gift_lines.forEach(removeItem);
            }
          }
        }

        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.error;
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
